// extracted by mini-css-extract-plugin
export default {"impersonationFooter":"ImpersonationFooter-impersonationFooter"};